import { useState } from 'react';
import {
    Link, Route, Routes, useLocation,
} from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import isAdmin from '../../service/adminAuth';
import NewOrder from './NewOrder';
import OrderDetails from './OrderDetails';
import OrderList from './OrderList';
import Organizations from './Organizations';
import './admin.css';

export default function Admin() {
    const {
        user, isLoading, isAuthenticated, loginWithRedirect,
    } = useAuth0();
    const location = useLocation();
    const [error, setError] = useState('');
    if (isLoading) {
        return (
            <section className="po-admin">
                <p>Loading your account…</p>
            </section>
        );
    }
    if (!isAuthenticated) {
        return (
            <section className="po-admin">
                <h1>Administration</h1>
                <p>Sign in with your administrator account.</p>
                {error && <p role="alert">{error}</p>}
                <button
                    type="button"
                    onClick={() => {
                        loginWithRedirect({
                            appState: {
                                returnTo: `${location.pathname}${location.search}${location.hash}`,
                            },
                        })
                            .catch(() => setError('Unable to start sign-in. Please try again.'));
                    }}>
                    Sign in
                </button>
            </section>
        );
    }
    if (!isAdmin(user)) {
        return (
            <section className="po-admin">
                <h1>Administrator access required</h1>
                <p>
                    Your account needs the Auth0 admin role. After it is assigned, sign out and
                    sign in again.
                </p>
            </section>
        );
    }
    return (
        <section className="po-admin">
            <header className="po-heading">
                <div>
                    <p className="po-eyebrow">STEAM LAB ADMINISTRATION</p>
                    <h1>Purchase orders</h1>
                </div>
            </header>
            <nav aria-label="Administration">
                <Link to="/admin">Orders</Link>
                <Link to="/admin/organizations">Purchasing organizations</Link>
                <Link to="/admin/new">New order</Link>
            </nav>
            <Routes>
                <Route
                    index
                    element={<OrderList />} />
                <Route
                    path="new"
                    element={<NewOrder />} />
                <Route
                    path="orders/:orderId"
                    element={<OrderDetails />} />
                <Route
                    path="organizations"
                    element={<Organizations />} />
                <Route
                    path="*"
                    element={(
                        <p>
                            Page not found.
                            <Link to="/admin">Return to orders</Link>
                        </p>
                    )} />
            </Routes>
        </section>
    );
}
